import { http } from './httpClient';
import { ISSUE_API } from './config';
import type {
  Comment,
  IntakeResponse,
  Issue,
  IssueDetail,
  IssueListResponse,
  ListFilters,
  Status,
} from '@/models/issue';

const BASE = `${ISSUE_API}/api/v1/issues`;

function qs(params: Record<string, unknown>): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '' && v !== null) q.set(k, String(v));
  }
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const issueApi = {
  intake: (text: string, screenshot_storage_id?: number) =>
    http<IntakeResponse>(`${BASE}/intake`, {
      method: 'POST',
      body: JSON.stringify({ text, screenshot_storage_id }),
    }),

  list: (filters: ListFilters = {}) =>
    http<IssueListResponse>(`${BASE}${qs(filters as Record<string, unknown>)}`),

  get: (id: number) => http<IssueDetail>(`${BASE}/${id}`),

  patch: (id: number, fields: Partial<Issue>) =>
    http<Issue>(`${BASE}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(fields),
    }),

  resolve: (
    id: number,
    body: { resolution_commit?: string; resolution_summary?: string; status?: Status }
  ) =>
    http<Issue>(`${BASE}/${id}/resolve`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),

  comment: (id: number, body: string) =>
    http<Comment>(`${BASE}/${id}/comments`, {
      method: 'POST',
      body: JSON.stringify({ body }),
    }),
};
